import { generateAvatarList } from './generator'

/**
 * Avatar list for child users.
 * Currently uses the default avatar path, but can be customized in the future
 * when child-specific assets are available.
 *
 * To customize when assets are ready:
 * generateAvatarList({ pathPrefix: 'avatar/child/', includeLegacyIds: true })
 */
export const childAvatarList = generateAvatarList({
  includeLegacyIds: true,
})
